import { userManager } from './userManager.js';

const SILENT_RENEW_ERROR = 'redux-oidc/SILENT_RENEW_ERROR';
const USER_EXPIRED = 'redux-oidc/USER_EXPIRED';

// createOidcMiddleware only subscribes to userLoaded (-> USER_FOUND). The events
// below have no subscriber at all, so an expired token or a failed silent renew
// never reaches redux and the player keeps sending a dead bearer token.
//
// Only the two token lifetime events are wired up. `userSignedOut` is left alone
// on purpose: the SessionMonitor raises it whenever its own querySessionStatus()
// call fails, and that call is a prompt=none request in a hidden iframe - exactly
// what a blocked third-party cookie on the STS looks like. The check session
// iframe polls every 2 seconds, so it fires within seconds of every login and
// bounces the user back through the STS, over and over. monitorSession is off for
// that reason (see userManager.js), and a session that really ended at the STS
// still surfaces here as an expired token at the latest.
export const registerOidcEvents = (store) => {
    userManager.events.addSilentRenewError((error) => {
        console.error('silent renew failed', error);
        store.dispatch({ type: SILENT_RENEW_ERROR, payload: error });
    });

    userManager.events.addAccessTokenExpired(() => {
        console.warn('access token expired');
        store.dispatch({ type: USER_EXPIRED });
    });
};
